import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const Title = () => (
    <Text className="pr-xl text-xl font-bold text-structure-100 min-m:text-2xl">
        <FormattedMessage
            id="_.loan_summary.mobile_summary_heading"
            defaultMessage="Your loan summary"
        />
    </Text>
);
